import { createApi } from "@reduxjs/toolkit/dist/query/react"
import { API_RPME_URL } from "constants/config"
import { authBaseQuery } from "../api"

if (!API_RPME_URL) {
  throw new Error("REACT_APP_API_RPME_URL is not defined")
}

export const rpmeApi = createApi({
  reducerPath: "rpmeApi",
  baseQuery: authBaseQuery(API_RPME_URL),
  tagTypes: ["SurveysRPME", "BaseXlsFormRPME", "XlsFormRPME", "BaseSchemasRPME", "XlsFormSchemaRPME"],
  endpoints: () => ({}),
})
